const MOBILE_MAX_WIDTH = 992;

export const isMobile = (width: number) => width < MOBILE_MAX_WIDTH;
